import React, { useContext, useEffect, useState } from "react";
import styled from "@emotion/styled";
import MUIDataTable from "mui-datatables";
import axios from "axios";

import { NavLink, useNavigate } from "react-router-dom";

//Components
import StaffManagementContext from "../../context/StaffManagementContext";
import {
  Avatar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Switch,
  TableRow,
  TableCell,
  Tooltip,
  IconButton,
  Stack,
  TextareaAutosize,
  Typography,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Detail from "./Detail";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import CustomizedSnackbars from "../300/curriculum/CustomizedSnackbars";
// import api from "../../../api/mainApi";

// ==============================|| Course List ||============================== //
const muiCache = createCache({
  key: "mui",
  prepend: true,
});
function Staffs() {
  const navigate = useNavigate();
  const api = useAxiosPrivate();
  const staffContext = useContext(StaffManagementContext);
  const [modalState, setModalState] = useState({
    open: false,
    name: null,
    staff_id: null,
    rejected: null,
  });
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });
  const [added, setAdded] = useState({ status: false });
  const [rejectReason, setRejectReason] = useState({ value: "", error: "" });
  const [inProgress, setInProgress] = useState(false);
  const handleClose = () => {
    setModalState({ ...modalState, open: false });
    //setSnackBarOpen(false);
    //setMessage({ message: "", type: "" });
  };
  const handleOpen = (staff_id, rejected) => {
    let staff = staffContext.state.filter((staff) => {
      return staff.id === staff_id;
    })[0];
    console.log(staff);
    setModalState({
      name:
        staff.first_name || staff.middle_name
          ? staff.first_name + " " + staff.middle_name
          : null,
      staff_id: staff_id,
      open: true,
      rejected: rejected,
    });
  };

  useEffect(() => {
    api.get("staff/staffs").then((res) => {
      staffContext.dispatch({
        type: "loadStaff",
        staffs: res.data.staffs,
      });
    });
  }, [added]);
  const handleDisable = () => {
    //alert(modalState.staff_id);
    setInProgress(true);
    if (modalState.rejected) {
      if (rejectReason.value) {
        api
          .delete("/staff/rejectStaff", {
            data: {
              id: modalState.staff_id,
              reason: rejectReason.value,
            },
          })
          .then((response) => {
            setRejectReason({ value: "", error: "" });
            alert(JSON.stringify(response, null, 2));
            setAdded({ status: true });
            setInProgress(false);
            setSnackBarOpen(true);
            setMessage({
              message: "Rejected Successfully",
              type: "success",
              overlay: true,
            });
          })
          .then(() => {
            handleClose();
          })
          .catch((err) => {
            alert(JSON.stringify(err.response.data, null, 2));
            setInProgress(false);
          });
      } else {
        setRejectReason({
          ...rejectReason,
          error: "Reject reason is required",
        });
        setSnackBarOpen(true);
        setMessage({ message: "Reject reason is required", type: "error" });
      }
    } else {
      api
        .delete("/staff/acceptStaff", {
          data: {
            id: modalState.staff_id,
          },
        })
        .then((response) => {
          alert(JSON.stringify(response, null, 2));
          setAdded({ status: true });
          setInProgress(false);
          setSnackBarOpen(true);
          setMessage({
            message: "Accepted Successfully",
            type: "success",
            overlay: true,
          });
        })
        .then(() => {
          handleClose();
        })
        .catch((err) => {
          alert(JSON.stringify(err.response.data, null, 2));
          setInProgress(false);
        });
    }
  };

  let staffs = staffContext.state
    .filter((s) => s.reg_status == "Pending")
    .map((staff) => {
      console.log(staff);
      let newstaff = {
        fullName: staff.first_name
          ? staff.first_name + " " + staff.middle_name
          : "",
        id: staff.id,
        phone_no: staff.phone_no,
        email: staff.email,
        qualification: staff.qualification,
        status: staff.status?.name,
        position: staff.position?.name,
        rank: staff.rank?.name,
        load: staff.load,
        office: staff.office?.name,
        start_date: staff.start_date,
        end_date: staff.end_date,
        disable: staff.id,
      };
      console.log("new staff, ", newstaff);
      return newstaff;
    });

  const columnHead = [
    {
      label: "Full Name",
      name: "fullName",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      label: "ID",
      name: "id",
      options: {
        filter: false,
        display: "none",
      },
    },
    {
      label: "Phone No",
      name: "phone_no",
      options: {
        filter: false,
        display: "exlude",
      },
    },
    {
      label: "Email",
      name: "email",
      options: {
        filter: true,
      },
    },
    {
      label: "Qualification",
      name: "qualification",
      options: {
        filter: true,
        display: "none",
      },
    },

    {
      label: "Employment Type",
      name: "status",
      options: {
        filter: true,
      },
    },
    {
      label: "Position",
      name: "position",
      options: {
        filter: true,
        display: "exclude",
      },
    },
    {
      label: "Academic Rank",
      name: "rank",
      options: {
        filter: true,
      },
    },
    //{
    //  label: "Load(LEH)",
    //  name: "load",
    //  options: {
    //    filter: false,
    //  },
    //},
    {
      label: "End Date",
      name: "end_date",
      options: {
        filter: false,
        display: "false",
      },
    },
    {
      label: "Department",
      name: "office",
      options: {
        filter: true,
        display: "none",
      },
    },
    {
      label: "Action",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{ width: "100px", display: "flex", alignItems: "center" }}
            >
              <Tooltip title="Accept">
                <IconButton onClick={() => handleOpen(value, false)}>
                  <CheckCircleOutlineIcon
                    fontSize="large"
                    sx={{ color: "green" }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Reject">
                <IconButton onClick={() => handleOpen(value, true)}>
                  <HighlightOffIcon fontSize="large" sx={{ color: "red" }} />
                </IconButton>
              </Tooltip>
              {tableMeta.tableData.filter((row) => {
                console.log(row.disable);
              })}
              {/*</NavLink>*/}
            </div>
          );
        },
      },
      name: "disable",
    },
  ];

  const options = {
    selectableRows: "none",
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      //course code is found using index

      const colSpan = rowData.length + 1;
      let staff = staffContext.state.filter((s) => rowData[1] === s.id)[0];
      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <Detail
              details={[
                {
                  office: staff.office.name,
                  position: staff.position.name,
                  [`phone number`]: staff.phone_no || "",
                  qualification: staff.qualification,
                },
                {
                  [`start date`]: staff.start_date,
                  [`end date`]: staff.end_date,
                },
              ]}
            />
          </TableCell>
        </TableRow>
      );
    },
  };
  let checkDate = (date) => {
    let end_date = new Date(date).getTime();
    let now = new Date().getTime();
    if (end_date > now || !date) {
      return true;
    }
    return false;
  };
  const StyledMUIDataTable = styled(MUIDataTable)(({ theme }) => ({
    background: theme.palette.background.default,
  }));
  return (
    <>
      <CacheProvider value={muiCache}>
        <StyledMUIDataTable
          title={""}
          data={staffs}
          columns={columnHead}
          options={options}
        />
      </CacheProvider>

      <Dialog open={modalState.open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">
          {!inProgress && (modalState.rejected ? "Reject " : "Accept ")}
          {!inProgress &&
            (modalState.name
              ? modalState.name + "?"
              : modalState.staff_id + "?")}
        </DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {inProgress == false && modalState.rejected == true && (
            <TextareaAutosize
              value={rejectReason.value}
              onChange={(e) => {
                //  alert(JSON.stringify(e, null, 2));
                //  console.log(rejectReason);
                setRejectReason({ error: "", value: e.target.value });
              }}
              minRows={3}
              aria-label="reject reason"
              placeholder="Insert your reject reason here..."
              //        defaultValue="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
              //  ut labore et dolore magna aliqua."
              style={{ width: 400 }}
            />
          )}
          {inProgress && (
            <CircularProgress
              color={modalState.rejected == true ? "danger" : "success"}
            />
          )}
          {rejectReason.error && snackBarOpen && (
            <CustomizedSnackbars
              {...{ setSnackBarOpen, snackBarOpen, message, overlay: true }}
            />
          )}
        </DialogContent>
        {!inProgress && (
          <DialogActions sx={{ padding: "1rem" }}>
            <Button
              onClick={handleClose}
              sx={{ color: "third.dark" }}
              size="small"
            >
              cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleDisable}
              sx={{
                color: "third.light",
                backgroundColor:
                  modalState.rejected == true ? "danger.light" : "success.main",
                "&:hover": {
                  backgroundColor:
                    modalState.rejected == true ? "danger" : "success.main",
                },
              }}
              size="small"
            >
              {modalState.rejected == true ? "Reject" : "Accept"}
            </Button>
          </DialogActions>
        )}
      </Dialog>
      {snackBarOpen && message.type == "success" && (
        <CustomizedSnackbars {...{ setSnackBarOpen, snackBarOpen, message }} />
      )}
    </>
  );
}

export default Staffs;
